export const stepLabel = 'Step 1 of 3';
export const spcStepLabel = 'Step 1 of 2';
export const bagLabel = 'Bag';
export const productLabel = 'Products';
export const placeOrder = 'Place Order';
export const proceedToShipping = 'Proceed To Shipping';
export const proceedToPayment = 'Proceed to Payment';
export const confirmOrder = 'Confirm Order';
export const viewDetails = 'View details';
export const applyCoupon = 'Apply Coupon';
export const ajioWallet = 'SuperCash';
export const knowMore = 'Know more';
export const select = 'Select';
export const remove = 'Remove';
export const freeDelivery = 'Free delivery on your order';
export const infocardTitle = {
  priceChange: 'Price Change Alert',
  restoredProducts: 'Bag Updated',
  oosProducts: 'Removed from Bag',
  limitedStock: 'Limited Stock'
};
export const infocardBody = {
  priceChange: 'Price Change Alert',
  restoredProducts: 'Your bag has been updated to reflect recent additions.',
  oosProducts: 'Unavailable products were removed from your bag and added to your wishlist.',
  limitedStock: 'The quantity of the products has been updated due to limited stock.',
  dealMessage: 'Few products in your bag have updated prices.'
};
export const addFromWishlistTitle = 'Add from Wishlist';
export const view = 'View';
export const MAX_IMAGE = 5;
export const couponSavings = 'Coupon Savings';
// Voucher
export const applicable = 'Applicable Coupons';
export const notApplicable = 'Not Applicable Coupons';
export const apply = 'Apply';
export const save = 'You save ';
export const tnc = 'View T&C';
export const couponApply = 'Coupon applied';
export const couponRemoved = 'Coupon removed';
export const verifiedAndApply = 'Verify and apply';
export const shopNow = 'Shop Now';
export const shopMoreToApply = (amount: string): string => `Shop for ${amount} more to apply offer`;
export const emailIDVerified = 'Email ID verification required';

export const cartErrorMessages = {
  100: 'Some of the products went out of stock',
  101: 'Bag has been Modified',
  102: 'Bag Error',
  103: 'Bag not found',
  104: 'Bag is Empty'
};

export const oosSize = 'Your size is currently out of stock';
export const oosItem = 'This product is currently out of stock';

// Rupees Symbol
export const ruppesSymbol = '₹';

// Bag button
export const addToBag = 'Add to Bag';

// new offers & benefits ui constants
export const noLoyaltyPoints = 'You have no wallets at the moment';
export const couponInputPlaceholder = 'Please enter a valid coupon code';
export const AJIO_CASH_WALLET = 'AJIO_CASH_WALLET';
export const RELIANCE_ONE_WALLET = 'RELIANCE_ONE_WALLET';
export const MAHA_CASHBACK = 'MAHA_CASHBACK';
export const internalWalletConstants = {
  [AJIO_CASH_WALLET]: 'AJIO Points',
  [RELIANCE_ONE_WALLET]: 'RelianceOne Points'
};
export const additionalBenefitConstants = {
  description: '{{NAME}} worth {{AMOUNT}}',
  footer: 'Can be used after return window closes'
};
export const offerBenefitsHeader = {
  couponApplied: 'Coupon Applied',
  loyaltyPoints: 'Wallets & Gift Card',
  ajioWallet: 'AJIO Cash',
  bankDiscounts: 'Bank Discounts',
  loyaltyPointsMsg: 'To use these points, you need to log in',
  ajioWalletMsg: 'AJIO Cash & Gift Card will be available once you log in',
  additionalBenefits: 'Additional Benefits'
};
export const nonLoggedInUserMsg =
  'Wallets & Gift Card consist of RelianceOne Points and AJIO Points. You can earn and redeem these points every time you shop at AJIO and Reliance Retail stores. Use the same mobile number whenever you shop with us to collect these points. <br><a href="https://www.ajio.com/jiomartmahabachat">Read T&C</a>.';
